import Reducer from 'modules/Finance/Wallets/reducer'
import Sagas from 'modules/Finance/Wallets/saga'
import Wallets from 'modules/Finance/Wallets/Wallets'
import { useWallets } from 'modules/Finance/Wallets/useWallets'
import { useWalletsActions } from 'modules/Finance/Wallets/useWalletsActions'

export default Wallets

export { Sagas, Reducer, useWallets, useWalletsActions }
